import React from 'react'
import { useSearchParams } from "react-router-dom";
import { getRedirectURI } from "../utils/redirectURI";
import { GITLAB_BASE_URL, GITLAB_CLIENT_ID } from '../config';

const RequestAccessCode = () => {
    const [seachParams] = useSearchParams()

    const namespace = seachParams.get('namespace');
    const project = seachParams.get('project');
    const ref = seachParams.get('ref');
    console.log({ namespace, project, ref });


    const redirectURI = getRedirectURI({
        project,
        namespace,
        ref,
    })

    window.location.href = `${GITLAB_BASE_URL}/oauth/authorize?client_id=${GITLAB_CLIENT_ID}&redirect_uri=${encodeURIComponent(redirectURI)}&response_type=code&state=STATE&scope=api`;

    return (
        <div />
    )
}

export default RequestAccessCode